import ModalBase from 'components/Modal/ModalBase';
import styled from 'styled-components';

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px 20px 16px;

  > h4 {
    margin: 0px;
    margin-bottom: 8px;

    font-weight: 600;
    font-size: 20px;
    line-height: 28px;

    color: #1b1c1e;
  }

  > p {
    margin-bottom: 32px;

    font-weight: 400;
    font-size: 16px;
    line-height: 24px;

    color: #70737c;
  }

  > button {
    width: fit-content;
    height: 48px;
    padding: 0px 24px;

    margin-left: auto;

    border-radius: 12px;
    background-color: #1b1c1e;

    color: #fff;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
  }
`;

interface Props {
  modalHandler: () => void;
  isMobile: boolean;
}

function CancelInfoModal({ modalHandler, isMobile }: Props) {
  return (
    <ModalBase
      isMobile={false}
      handleModal={modalHandler}
      useCustomHeader
      style={{
        maxWidth: '351px',
      }}
    >
      <ModalContent>
        <h4>이미 취소를 요청한 옵션이 있어서 전체 취소는 불가능해요.</h4>
        <p>요청을 철회한 후 다시 시도해 주세요.</p>

        <button onClick={modalHandler}>네, 확인했어요</button>
      </ModalContent>
    </ModalBase>
  );
}

export default CancelInfoModal;
